/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Colormode1Inputs */

const en_settings_colormode1 = /** @type {(inputs: Settings_Colormode1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color mode`)
};

/**
* | output |
* | --- |
* | "Color mode" |
*
* @param {Settings_Colormode1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_colormode1 = /** @type {((inputs?: Settings_Colormode1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Colormode1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_colormode1(inputs)
});
export { settings_colormode1 as "settings_colorMode" }